export default "/kiban/_next/static/images/03_metal-374c695b135c8faba469ad9c8deb76bc.png";